export default __webpack_public_path__ + "static/recent-work-4-9911fe0f46a8303b0783794a046d02cf.png";